<div class="input-number">
  <ion-input class="form-input" type="number" [class.input-error]="invalid()" [value]="internalValue()"
    [disabled]="disabled()" [min]="min()" (ionInput)="handleInput($event)" (ionBlur)="inputBlur.emit()"
    (keydown.arrowup)="handleArrow($event, 1)" (keydown.arrowdown)="handleArrow($event, -1)">
  </ion-input>
  <span class="stepper">
    <button type="button" class="stepper-hit stepper-up" data-testid="input-stepper-up" tabindex="-1"
      [disabled]="disabled()" (click)="step(1)"></button>
    <button type="button" class="stepper-hit stepper-down" data-testid="input-stepper-down" tabindex="-1"
      [disabled]="disabled()" (click)="step(-1)"></button>
  </span>
</div>
